import * as yup from 'yup';

import messages from '@giro-auth/constants/messagesSchema.util';

export const formSchema = yup.object({
  email: yup.string().email(messages.EMAIL).required(messages.REQUIRED),
});
